
//  MaterialModal.js

import React, { useState, useEffect } from 'react';
import { useTheme } from '../contexts/ThemeContext.js';
import './MaterialModal.css';

function MaterialModal({ material, onSave, onClose }) {
  const [id, setId] = useState(material.id || null);
  const [codmat, setCodmat] = useState(material.codmat);
  const [materialNome, setMaterialNome] = useState(material.material);
  const [valcompra, setValcompra] = useState(material.valcompra);
  const { theme } = useTheme();

  // Função para formatar os valores para BRL
  const formatarValorBRL = (valor) => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
  };

  // Função para lidar com a alteração do valor
  const handleValorChange = (e) => {
    const input = e.target.value;
    const numericValue = parseFloat(input.replace(/[\D]/g, '')) / 100; // Remove caracteres não numéricos e divide por 100
    setValcompra(formatarValorBRL(numericValue)); // Atualiza com o valor formatado
  };

  // useEffect para carregar os dados do material no modal
  useEffect(() => {
    setId(material.id || null);
    setCodmat(material.codmat);
    setMaterialNome(material.material);
    setValcompra(formatarValorBRL(material.valcompra || 0)); // Formata valcompra em BRL ao abrir o modal
  }, [material]);

  const handleSave = () => {
    // Converte o valor formatado para um número
    let valorNumerico = 0;

    if (typeof valcompra === 'string') {
      valorNumerico = parseFloat(
        valcompra.replace(/[^\d,.-]/g, '').replace(',', '.')
      );
    } else {
      valorNumerico = parseFloat(valcompra);
    }

    const updatedProduto = {
      id,
      codmat,
      material: materialNome,
      valcompra: valorNumerico,
    };

    onSave(updatedProduto);
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Material</h2>
        <form className="form-container">
          <div className="form-group">
            <label>Código</label>
            <input
              type="text"
              value={codmat}
              onChange={(e) => setCodmat(e.target.value)}
              style={{ backgroundColor: theme.fieldBackground, color: theme.color, width: '200px' }}
            />
          </div>
          <div className="form-group">
            <label>Material</label>
            <input
              type="text"
              value={materialNome}
              onChange={(e) => setMaterialNome(e.target.value)}
              style={{ backgroundColor: theme.fieldBackground, color: theme.color, width: '300px' }}
            />
          </div>
          <div className="form-group">
            <label>Valor</label>
            <input
              type="text"
              value={valcompra}
              //onChange={(e) => setValcompra(e.target.value)}
              onChange={handleValorChange}
              style={{ backgroundColor: theme.fieldBackground, color: theme.color, width: '200px' }}
            />
          </div>
        </form>
        <div className="modal-actions">
          <button 
            onClick={handleSave} 
            className="btn" 
            style={{ backgroundColor: theme.buttonBackground, padding: '5px 5px', color: theme.buttonText }}
          >
            Salvar
          </button>
          <button 
            onClick={onClose} 
            className="btn" 
            style={{ backgroundColor: theme.buttonBackground, padding: '5px 5px', color: theme.buttonText }}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}

export default MaterialModal;